import React from "react";
import "./about.css";

const About = () => {
  return (
    <div className="about">
      {/*<h1>What we Believe in </h1> 
        <br></br>
        <h2>JurisTech - Bridging Technology and Law for a Connected Future</h2>
        <br></br>
       <div className="statement"> 
       
       <img src="https://images.pexels.com/photos/159832/justice-law-case-hearing-159832.jpeg?auto=compress&cs=tinysrgb&w=600" alt="alternatetext"></img>
       <div id = "us1"></div>
       <p>JurisTech is a leading consultancy firm specializing in the intersection of technology and the law. With a team of highly skilled professionals, we offer comprehensive services to businesses, organizations, and individuals seeking expert guidance in navigating the legal complexities of the rapidly evolving technological landscape.</p> 
       </div>*/}

      <div id="firm">
        <h2>Our Firm</h2>
      </div>
      <div id="weare">
        <img id="sr"
          src="https://images.pexels.com/photos/6615227/pexels-photo-6615227.jpeg?auto=compress&cs=tinysrgb&w=600"
          alt="Managing Partner"
        ></img>
        <img id="sr"
          src="https://images.pexels.com/photos/3769021/pexels-photo-3769021.jpeg?auto=compress&cs=tinysrgb&w=600"
          alt="Senior Partner"
        ></img>
        <img id="sr"
          src="https://images.pexels.com/photos/10376248/pexels-photo-10376248.jpeg?auto=compress&cs=tinysrgb&w=600"
          alt="Senior Partner"
        ></img>
      </div>
      <div id="partnernames">
        <h4>
          Jack W. Daniels <br /> Senior Partner
        </h4>
        <h4>
          Rose G. Gundogan <br /> Managing Partner{" "}
        </h4>
        <h4>
          Captain F. Morgan <br /> Senior Partner{" "}
        </h4>
      </div>

      <div id="roles">
        <h4>
          As the Senior Partner in the Technology Law and Corporate Law division
          at Juristech, I play a pivotal role in leading and overseeing our
          legal practice in these areas. With extensive experience and expertise
          in technology and corporate law, I bring valuable insights and
          strategic guidance to our team and clients.
        </h4>
        <h4>
          As the Managing Partner, my role is to lead Juristech towards its
          strategic objectives, drive growth and profitability, cultivate client
          relationships, foster a positive work culture, and ensure operational
          efficiency. I take on a multifaceted role that requires effective
          leadership, strategic thinking, and a commitment to delivering
          exceptional legal services to our clients.
        </h4>
        <h4>
          As the Senior Partner in the Civil Law and Divorce Law division, I am
          dedicated to upholding the highest standards of legal representation,
          providing compassionate guidance to clients, and fostering the
          professional growth of our team. I strive to deliver successful
          outcomes and resolve legal disputes efficiently and effectively in the
          civil law and divorce law realms.
        </h4>
      </div>
      <br></br>
      <br></br>
      <div id="title">
        <h2>Our Practice Areas</h2>
      </div>

      <div id="practiceareas">
        <div id="practice1">
          <h3>
            Information Technology <br /> Law
          </h3>
          <h5>
            {" "}
            Our IT Law experts provide comprehensive legal advice tailored to
            our clients' specific needs. We assist in drafting and reviewing IT
            agreements, creating data protection policies, conducting compliance
            assessments, and advising on global regulations such as GDPR and
            CCPA. With our in-depth knowledge of the legal intricacies
            surrounding technology, we empower our clients to make informed
            decisions and minimize potential risks. <br />{" "}
            <a href="https://example.com" target="_blank">
              Learn More
            </a>
          </h5>
        </div>
        <div id="practice2">
          <h3>
            Corporate
            <br /> Law
          </h3>
          <h5>
            {" "}
            We assist clients in structuring their businesses, ensuring
            compliance with applicable laws and regulations, and mitigating
            risks associated with corporate transactions. Our goal is to provide
            practical and strategic legal advice that aligns with our clients'
            business objectives, enabling them to make informed decisions and
            navigate the corporate landscape with confidence.vitae erat.
            <br />{" "}
            <a href="https://example.com" target="_blank">
              Learn More
            </a>
          </h5>
        </div>
        <div id="practice3">
          <h3>
            Civil <br /> Law
          </h3>
          <h5>
            Our Civil Law practice covers a broad spectrum of areas, including
            contract disputes, tort claims, property disputes, employment law
            matters, personal injury cases, and more. Whether you are seeking
            compensation, defending your rights, or seeking resolution through
            negotiation or litigation, our experienced civil law attorneys will
            work diligently to protect your interests and achieve the best
            possible outcome for your case. <br />{" "}
            <a href="https://example.com" target="_blank">
              Learn More
            </a>
          </h5>
        </div>
      </div>
    </div>
  );
};

export default About;
